import { Link } from "react-router-dom";
import { Mail, MapPin } from "lucide-react";
import { Logo } from "@/components/Logo";
import { FOOTER, CONTACTS } from "@/content/site";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-azeka-navy text-slate-300">
      <div className="container-x py-14 lg:py-16">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <Logo onDark className="h-10 w-auto" />
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-slate-400">
              {FOOTER.tagline}
            </p>
            <div className="mt-6 space-y-3 text-sm">
              <a
                href={`mailto:${CONTACTS.general}`}
                data-testid="footer-email-general"
                className="flex items-center gap-3 text-slate-300 hover:text-azeka-teal2 transition-colors"
              >
                <Mail className="h-4 w-4 text-azeka-teal2" />
                {CONTACTS.general}
              </a>
              <a
                href={`mailto:${CONTACTS.trade}`}
                data-testid="footer-email-trade"
                className="flex items-center gap-3 text-slate-300 hover:text-azeka-teal2 transition-colors"
              >
                <Mail className="h-4 w-4 text-azeka-teal2" />
                {CONTACTS.trade}
              </a>
              <p className="flex items-center gap-3 text-slate-400">
                <MapPin className="h-4 w-4 text-azeka-teal2" />
                {CONTACTS.location}
              </p>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-8 lg:col-span-5 lg:col-start-8">
            {FOOTER.columns.map((col) => (
              <div key={col.title}>
                <h4 className="text-sm font-semibold uppercase tracking-wider text-white">
                  {col.title}
                </h4>
                <ul className="mt-4 space-y-3">
                  {col.links.map((l) => (
                    <li key={l.to}>
                      <Link
                        to={l.to}
                        data-testid={`footer-link-${l.to.replace("/", "")}`}
                        className="text-sm text-slate-400 hover:text-azeka-teal2 transition-colors"
                      >
                        {l.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-12 border-t border-white/10 pt-8">
          <div className="flex flex-col gap-5 sm:flex-row sm:items-center sm:justify-between">
            <nav className="flex flex-wrap items-center gap-x-5 gap-y-2" aria-label="Legal">
              {FOOTER.legal.map((l) => (
                <a
                  key={l.label}
                  href={l.to}
                  data-testid={`footer-legal-${l.label.toLowerCase().replace(/[^a-z]+/g, "-").replace(/(^-|-$)/g, "")}`}
                  className="text-xs text-slate-400 hover:text-azeka-teal2 transition-colors"
                >
                  {l.label}
                </a>
              ))}
            </nav>
            <p className="text-xs text-slate-500">
              © {new Date().getFullYear()} Azeka Global Trade FZCO. All rights reserved.
            </p>
          </div>
          <p className="mt-6 text-[11px] leading-relaxed text-slate-600" data-testid="footer-licence">
            {FOOTER.licence}
          </p>
        </div>
      </div>
    </footer>
  );
};
